import { render, staticRenderFns } from "./dr-text-area.vue?vue&type=template&id=5d40a62a&scoped=true"
import script from "./dr-text-area.vue?vue&type=script&lang=js"
export * from "./dr-text-area.vue?vue&type=script&lang=js"
import style0 from "./dr-text-area.vue?vue&type=style&index=0&id=5d40a62a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40a62a",
  null
  
)

export default component.exports